<app-inactivity-timer [IsTimerOpenPopup]="IsTimerOpenPopup" (SetTimerOpenPopup)="TimerOpenPopupChange($event)"></app-inactivity-timer>
<router-outlet></router-outlet>
